import React, {useEffect, useState} from 'react';
import TakisHero from "../components/TakisHero"
import useProductsData from '../hooks/useProductsData';
import TakisGrid from '../components/TakisGrid';
import TakisHeroSkeleton from "../components/Skeletons/TakisHeroSkeleton";
import TakisGridSkeleton from "../components/Skeletons/TakisGridSkeleton";
import TakisRecipeListSkeleton from "../components/Skeletons/TakisRecipeListSkeleton"
import TakisRecipeList from '../components/TakisRecipeList';
import TakisSocial from '../components/TakisSocial';

const Products = ({pagePath}) => {
  const [categoryData, setCategoryData] = useState('');
  const { error, isLoading, productsQueryData } = useProductsData(pagePath);

  useEffect(() => {
    if (productsQueryData) {
      setCategoryData(productsQueryData);
    }
  }, [productsQueryData]);

  if (isLoading || error || !categoryData) {
    return (
      <>
        <TakisHeroSkeleton/>
        <TakisGridSkeleton/>
        <TakisRecipeListSkeleton/>
      </>
    );
  }

  // Verificar si es la sección de multipacks
  const isMultipacksSection =
    pagePath?.toLowerCase().includes('multipack') ||
    categoryData?.gridCategory?.title?.toLowerCase().includes('multipack');

  return (
    <>
      <TakisHero
        data={categoryData.hero}
        isProductPage={true}
      />
      <TakisGrid
        title={categoryData.gridCategory.title}
        items={categoryData.gridCategory.items}
        flattop={true}
        disableLinks={isMultipacksSection}
      />
      <TakisSocial data={categoryData.social}/>
      <TakisRecipeList
        pageType={'Recipes'}
        title={productsQueryData.recipesComponent.title}
        recipeCTA={productsQueryData.recipesComponent.recipeCTA}
        recipesPageCTA={productsQueryData.recipesComponent.recipesPageCTA}
        initialRecipes={categoryData.recipesSection.recipes}
        isStatic={true}
      />
    </>
  );
};

export default Products;
